import { wishListSharingStatusStyles } from "@insite/content-library/Components/WishListSharingStatus";

wishListSharingStatusStyles.privateTooltip = {
    iconProps: {
        color: "#636161",
    },
};
